/**
 * Created by lzy 19-11-03
 * 百家号废稿箱路由
 */
"use strict";
angular.module("editBaijiahaoDraftBoxRouterModule", []).
config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
  $stateProvider.state('front.editctr.baijiahao.draftbox', {
    url: '/draftbox?account&channelid',//account->账号
    views: {
      "main@front.editctr": {
        templateUrl: "./editingCenter/baijiahao/draftBox/main.html",
        controller: "EditBaijiahaoDraftBoxCtrl"
      }
    }
  });
}]);
